import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { Divider, Flex, message } from 'antd'
import { TbLoader2 } from 'react-icons/tb'

// components
import JobInfoDrawer from './JobInfoDrawer'
import JobApplications from './JobApplications'
import AddEditJob from '../../jobs/components/AddEditJob'
import BackAndEdit from '../../../components/backAndEdit'

// store
import {
    getJobDetails,
    jobState,
    switchJobModal,
} from '../../jobs/store/job.slice'
import {
    getJobApplicantListByStatus,
    getStatusWiseCount,
    jobApplicantState,
} from '../store/jobApplicant.slice'

// constants
import { JOB_APPLICATIONS_STATUS } from '../../../constants/jobs'
import { apiJobUpdate } from '../../jobs/store/job.service'
import { PRIVATE_ROUTES } from '../../../routes'

export const initialState = {
    jobStatus: 'matches',
    jobIndex: 0,
    selectedApplicantData: null,
    selectedApplicantIndex: null,
    jobStatusList: [],
    jobInfoDrawer: false,
    jobApplicantResumeDrawer: false,
    jobApplicantNotesDrawer: false,
}

const JobDetailsBanner = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params = useParams()

    const [state, setState] = useState(initialState)

    const { modalVariations, jobDetails, jobLoading } = useSelector(jobState)
    const jobApplicantStateData = useSelector(jobApplicantState)

    const handleBack = () => {
        dispatch(
            switchJobModal({
                ...modalVariations,
                open: false,
                isEdit: false,
                selectedJobID: null,
            })
        )
        navigate(-1)
    }

    const handleEditJobDetails = () => {
        if (params.id) {
            dispatch(
                switchJobModal({
                    ...modalVariations,
                    open: true,
                    isEdit: true,
                    selectedJobID: params.id,
                })
            )
        }
    }

    const handleArchive = async () => {
        try {
            const data = {
                isArchived: true,
            }

            let response = null

            const payload = {
                updatedData: data,
                _id: params.id,
            }

            response = await apiJobUpdate(payload)

            if (response?.data?.success) {
                message.success(response?.data?.message)

                navigate(PRIVATE_ROUTES.jobs)
            } else {
                message.error(response?.data?.message)
            }
        } catch (error) {
            console.log('error ====>', error)
        }
    }

    const handleSelectApplicationStatus = (status, index) => {
        setState((prevState) => ({
            ...prevState,
            jobStatus: status.key,
            jobIndex: index,
            selectedApplicantData: null,
            selectedApplicantIndex: null,
        }))

        dispatch(
            getJobApplicantListByStatus({
                filter: { status: status.key, job: params.id },
            })
        )
    }

    // const handleViewJobInfo = () => {
    //     setState((prevState) => ({
    //         ...prevState,
    //         jobInfoDrawer: true,
    //     }))
    // }

    useEffect(() => {
        if (params.id) {
            dispatch(getJobDetails(params.id))
            dispatch(getStatusWiseCount({ jobId: params.id }))
            dispatch(
                getJobApplicantListByStatus({
                    filter: { status: 'matches', job: params.id },
                })
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id])

    useEffect(() => {
        let updatedList = []
        let jobApplicantionsStatus = JOB_APPLICATIONS_STATUS

        if (jobApplicantStateData?.statusList?.length > 0) {
            jobApplicantionsStatus.forEach((status) => {
                const foundItem = jobApplicantStateData?.statusList.find(
                    (item) => status?.value === item?.status
                )
                const value = foundItem ? foundItem.count : 0
                updatedList.push({
                    name: status?.label,
                    value,
                    key: status?.value,
                })
            })
        }

        if (jobApplicantStateData?.statusList?.length === 0) {
            jobApplicantionsStatus.map((status) => {
                updatedList.push({
                    name: status?.label,
                    value: 0,
                    key: status?.value,
                })
            })
        }

        setState((prevState) => ({
            ...prevState,
            jobStatusList: updatedList,
        }))
    }, [jobApplicantStateData])

    useEffect(() => {
        if (jobApplicantStateData?.loaders?.applicantLoading) {
            setState((prevState) => ({
                ...prevState,
                selectedApplicantData: null,
                selectedApplicantIndex: null,
            }))
        }
    }, [jobApplicantStateData?.loaders?.applicantLoading])

    return (
        <>
            {jobLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <TbLoader2
                        size={30}
                        className="spin-loader-resume"
                        color="#4f46e5"
                    />
                </div>
            ) : (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                            }}
                        >
                            <h3>{jobDetails?.title || ''}</h3>
                            <h3>({jobDetails?.noOfPositions || 0})</h3>

                            {/* <span
                                style={{
                                    border: '1px solid #C9C9C9',
                                    borderRadius: '5px',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    padding: '3px 12px',
                                    cursor: 'pointer',
                                }}
                                onClick={handleViewJobInfo}
                            >
                                Job Info <RightArrow />
                            </span> */}
                        </div>

                        <BackAndEdit
                            onBack={handleBack}
                            onEdit={handleEditJobDetails}
                            state={state}
                            params={params}
                            onArchive={handleArchive}
                        />
                    </div>

                    <Flex
                        justify="flex-start"
                        align="center"
                        gap={10}
                        style={{
                            marginBottom: '10px',
                        }}
                    >
                        <div>
                            <span
                                style={{
                                    fontWeight: 400,
                                    color: '#919EAB',
                                    fontSize: '16px',
                                }}
                            >
                                {jobDetails?.location || ''}
                            </span>
                        </div>
                        <span
                            style={{
                                color: '#4F46E5',
                                fontSize: '20px',
                                textTransform: 'capitalize',
                            }}
                        >
                            {jobDetails?.status || ''}
                        </span>
                        <span
                            style={{
                                background: jobDetails?.isActiveJob
                                    ? '#36B37E29'
                                    : '#FF563029',
                                color: jobDetails?.isActiveJob
                                    ? '#1B806A'
                                    : '#B71D18',
                                fontWeight: 700,
                                fontSize: '18px',
                                padding: '3px 12px',
                                borderRadius: '9px',
                            }}
                        >
                            {jobDetails?.isActiveJob ? 'Active' : 'Inactive'}
                        </span>
                    </Flex>

                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '36px',
                            marginTop: '20px',
                        }}
                    >
                        {state.jobStatusList?.map((status, index) => (
                            <Flex
                                key={index}
                                onClick={() =>
                                    handleSelectApplicationStatus(status, index)
                                }
                                style={{
                                    cursor: 'pointer',
                                    padding: '12px 16px', // more padding inside each tab
                                    flex: '0 1 auto',
                                    color:
                                        state.jobIndex === index
                                            ? '#4F46E5'
                                            : '#111827',
                                    fontWeight:
                                        state.jobIndex === index ? 700 : 500,
                                    fontSize: '15px',
                                    borderRadius: '8px', // optional, makes it look cleaner
                                    transition:
                                        'color 0.2s ease, font-weight 0.2s ease, background 0.2s ease',
                                    backgroundColor:
                                        state.jobIndex === index
                                            ? '#DBD9FF'
                                            : 'transparent', // subtle highlight
                                }}
                            >
                                <span style={{ marginRight: '8px' }}>
                                    {status.name}
                                </span>
                                <span
                                    style={{
                                        fontWeight: 500,
                                        fontSize: '15px',
                                        color:
                                            state.jobIndex === index
                                                ? '#4F46E5'
                                                : '#9ca3af',
                                    }}
                                >
                                    {status.value}
                                </span>
                            </Flex>
                        ))}
                    </div>
                </>
            )}

            <Divider />

            <div>
                <JobApplications state={state} setState={setState} />
            </div>

            <AddEditJob from="applicant" />

            <JobInfoDrawer state={state} setState={setState} />
        </>
    )
}

export default JobDetailsBanner
